import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { IpcChannel, IpcV2Service } from 'src/app/services/ipc-v2.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  isLoading = false;
  loginForm = new UntypedFormGroup({
    email: new UntypedFormControl('', Validators.email),
    password: new UntypedFormControl(''),
  });
  constructor(private api:ApiService, 
      private auth:AuthService, 
      private router:Router,
      private ipcV2:IpcV2Service,
      private alertService : AlertService) { }

  ngOnInit(): void {

  }

  login(){
    this.isLoading = true;
    this.api.authenticate(this.loginForm.value.email, this.loginForm.value.password)
    .subscribe(res=>{
      this.isLoading = false;
      this.auth.saveUser(res);
      this.ipcV2.sendAndReceive(IpcChannel.SAVE_USER, res).subscribe();
      this.router.navigate(['/home']);
    }, (err: HttpErrorResponse)=>{
      this.isLoading = false;
      this.alertService.toast(err.message);
    });

  }

}
